import { fetchSakinler as fetchSakinlerAPI } from '../../services/WebsiteService';

export const FETCH_SAKINLER_SUCCESS = "FETCH_SAKINLER_SUCCESS";
export const FETCH_SAKINLER_ERROR = "FETCH_SAKINLER_ERROR";

const fetchSakinlerSuccess = (sakinler, pagination = null) => ({
    type: FETCH_SAKINLER_SUCCESS,
    payload: { sakinler, pagination },
});

const fetchSakinlerError = (error) => ({
    type: FETCH_SAKINLER_ERROR,
    payload: error,
});

export const fetchSakinler = (sakinler = null, page = 1, perPage = 12) => {
    return async (dispatch) => {
        try {
            // Eğer sakinler parametre olarak gelmişse (fallback), onu kullan
            if (sakinler) {
                dispatch(fetchSakinlerSuccess(sakinler, null));
                return;
            }
            
            // API'den çek (sayfalama ile)
            const result = await fetchSakinlerAPI(page, perPage);
            dispatch(fetchSakinlerSuccess(result.items, result.pagination));
        } catch (error) {
            console.error('Sakinler fetch error:', error);
            dispatch(fetchSakinlerError(error.message));
            // Fallback: JSON'dan yükle
            try {
                const fallback = await import('../../data/sakinler.json');
                dispatch(fetchSakinlerSuccess(fallback.default, null));
            } catch (e) {
                dispatch(fetchSakinlerSuccess([], null));
            }
        }
    };
};
